// DownloadItem.vue（ポップアップ表示・離脱・ログイン成功の計測元）と
// firebase-lib.js（リダイレクト系ログインの復帰処理）の双方から参照する共有キー。
//
// Google/AppleID/LINEのログインは signInWithRedirect / 外部URL遷移で一度ページを離れるため、
// DownloadItem.vue が保持する loginPopupTracking（メモリ上のフラグ）はページ再読み込みで
// 失われてしまい、戻ってきても login_popup_login_success を送信できない。
// そこでポップアップを開いた時点でこのキーを使って計測コンテキストを永続ストレージ
// （localforage）に退避し、リダイレクト復帰後の認証確定時に
// firebase-lib.js 側で回収して成功イベントを送信する。
export const LOGIN_POPUP_REDIRECT_KEY = 'loginPopupRedirectTracking'
